export default __webpack_public_path__ + "static/pineapple_adventure_2-7c49fd6670b8fcda6c225930190ba3d3.png";